import { connect } from 'react-redux'
import SuccessCriteriaSlideCreateDialog from './create-dialog.jsx'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getCreateSlideRequest } from '../../../../stores/presentation/presentation.selectors.js'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'
import { filterCriteria } from '../helpers.js'

const mapStateToProps = state => {
  const createSlideModal = getCreateSlideDialog(state)
  return {
    modalOpened:
      createSlideModal.opened && createSlideModal.type === 'SuccessCriteria',
    pending: getCreateSlideRequest(state).pending
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    dispatch(
      createSlide({
        type: 'SuccessCriteria',
        title: values.title,
        criteria: filterCriteria(values.criteria)
      })
    ).catch(errorHandler)
  },
  onClose: () => dispatch(closeCreateSlideDialog())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessCriteriaSlideCreateDialog)
